"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _marked = require("marked");

var TextComponent = function TextComponent(_ref) {
  var component = _ref.component;
  var html = component.format === 'markdown' ? _marked.marked.parse(component.message) : component.message;
  return (0, _preact.h)("div", {
    className: "forethought-agent__text",
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};

var _default = TextComponent;
exports.default = _default;